import axios from 'axios';

const isLocal = typeof window !== 'undefined' && window.location?.hostname === 'localhost';
const localApiBase = 'http://localhost:5001/api';
const localImageBase = 'http://localhost:5001';
// Production: same origin (app.notiz.se serves both frontend and API)
const origin = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : 'https://app.notiz.se';
export const baseApi = isLocal ? localApiBase : (process.env.REACT_APP_URL_API || `${origin}/api`);
export const imgUrl = isLocal ? localImageBase : (process.env.REACT_APP_URL_IMAGE || origin);

export const api = axios.create({
    baseURL: baseApi,
    withCredentials:true,
    // headers:{
    //     'Content-type':['multipart/form-data','application/json'],
    //     Accept:'application/json'
    // }
})